import { gql } from '@apollo/client';

export default {
  users: {
    name: 'users',
    serviceName: 'unitadmin',
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            addresses {
              id
              lat
              lng
              title
              tellphone
              is_default
              main_street
              minor_address
            }
          }
        }
      }
    `,
  },
};
